import { Tabs as MuiTabs, TabsProps as MuiTabProps } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import { DesignToken } from '~c/components/base/core';

export interface TabsProps extends MuiTabProps {
  className?: string;
}

const TabsImpl: React.FC<TabsProps> = ({ className, ...props }) => {
  return <MuiTabs className={className} {...props} />;
};

/**
 * Customized MUI Tabs component.
 *
 * It inherits all properties of a MUI Tabs
 */
export const Tabs = muiStyled(TabsImpl)(
  ({ theme }) => css`
    .MuiTabs-scrollButtons {
      color: ${DesignToken.brand.primaryContrast};
    }
  `
);
export default Tabs;
